// extracted by mini-css-extract-plugin
export var container = "_fj-0";
export var icon = "_fj-1";
export var text = "_fj-2";